"use strict";
'kiwi public';

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _vue = require("vue");
var _state = _interopRequireDefault(require("@/libs/state"));
var _UserAvatarCommon = require("./UserAvatarCommon");
var _default = exports.default = {
  __name: 'UserAvatar',
  props: {
    user: {
      type: Object,
      default: null
    },
    message: {
      type: Object,
      default: null
    },
    network: {
      type: Object,
      default: null
    },
    size: {
      type: String,
      default: 'small'
    },
    forceShowStatus: {
      type: Boolean,
      default: false
    },
    allowToggle: {
      type: Boolean,
      default: false
    }
  },
  setup(__props) {
    const props = __props;
    const state = (0, _state.default)();
    const getSizeObj = size => ({
      url: props.user.avatar[size],
      vbind: {
        'href': props.user.avatar[size],
        'xlink:href': props.user.avatar[size]
      },
      setFailed: () => {
        const avatar = props.user.avatar;
        const failedAvatar = avatar[size];
        avatar[size] = '';
        if (!avatar.small && !avatar.large) {
          state.$emit('user.avatar.failed', {
            user: props.user,
            network: props.network,
            failed: failedAvatar
          });
        }
      }
    });
    const shouldShowStatus = () => {
      if (!props.network || !props.user || !props.user.isAway) {
        return false;
      }
      if (props.forceShowStatus) {
        return true;
      }
      if (props.network.state !== 'connected' || !state.setting('showAwayStatusIndicators')) {
        return false;
      }
      const awayNotifyEnabled = props.network.ircClient.network.cap.isEnabled('away-notify');
      return state.setting('buffers.who_loop') || awayNotifyEnabled;
    };
    const awayStatus = (0, _vue.computed)(() => {
      const show = shouldShowStatus();
      const vbind = {};
      if (show) {
        vbind.mask = 'url(#kiwi-avatar-mask)';
      }
      const transform = (0, _UserAvatarCommon.getAvatarTransform)();
      return {
        show,
        vbind,
        transform
      };
    });
    const avatar = (0, _vue.computed)(() => {
      let initialsLength = state.setting('avatars.initials_length');
      if (!initialsLength || initialsLength < 1) {
        initialsLength = 1;
      }
      if (initialsLength > 2) {
        initialsLength = 2;
      }
      const nick = props.message?.nick || props.user?.nick || 'User';
      const initials = nick.substring(0, initialsLength).toUpperCase();
      const hasImage = !!(props.user && (props.user.avatar.small || props.user.avatar.large));
      const showBackground = !hasImage || state.setting('avatars.show_image_background');
      const backgroundStyle = {};
      const avatars = {
        hasImage,
        initials,
        showBackground,
        backgroundStyle,
        sizeKey: {}
      };
      if (!props.user) {
        return avatars;
      }
      if (props.user.getColour) {
        backgroundStyle.fill = props.user.getColour();
      }
      if (props.user.avatar.small) {
        avatars.small = getSizeObj('small');
        avatars.sizeKey.small = 'small';
        if (!props.user.avatar.large) {
          avatars.sizeKey.large = 'small';
        }
      }
      if (props.user.avatar.large) {
        avatars.large = getSizeObj('large');
        avatars.sizeKey.large = 'large';
        if (!props.user.avatar.small) {
          avatars.sizeKey.small = 'large';
        }
      }
      return avatars;
    });
    const toggleAway = () => {
      if (!props.allowToggle || props.user.away === 'offline') {
        return;
      }
      const isAway = props.user.isAway();
      props.network.ircClient.raw('AWAY', isAway ? '' : 'Currently away');
    };
    return {
      __sfc: true,
      state,
      props,
      getSizeObj,
      shouldShowStatus,
      awayStatus,
      avatar,
      toggleAway
    };
  }
};
window._kiwi_exports = window._kiwi_exports || {};
if(!window._kiwi_exports["components"]) window._kiwi_exports["components"] = {};
window._kiwi_exports["components"]["UserAvatar"]
window._kiwi_exports.components.UserAvatar = exports.default ? exports.default : exports;
